import React, { useEffect, useRef, useState } from 'react';
import './geography.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useIntl } from 'react-intl';
import { NavLink } from 'react-router';
import {
  getPaginationOpts,
  responseLogWithNotification, useFilterForm,
  useUpdatePeriod,
} from '../../../utils/utils';
import { loadHistoryById, loadGeographyHistory } from '../actions';
import { getSystemData } from '../../System/reducer';
import Loader from '../../../components/base/Loader/Loader';
import { getGeographyData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../components/fields/TextInput/TextInput';
import {
  dateFormatter,
  dateTimeFormatter,
  userFullNameFormatter,
} from '../../../utils/formatters';
import HistoryDialog from './HistoryDialog';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import { GEOGRAPHY_MODULE } from '../../../configs/moduleNames';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import CustomSelectInputWithHelper from '../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import { loadUserList } from '../../User/actions';

export default function HistoryPage() {
  const blockRef = useRef(null);
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const store = useStore();
  const [selectedItem, setSelectedItem] = useState(null);
  const { updatePeriod } = useSelector(getSystemData);
  const {
    geographyHistory = [],
    loadingGeographyHistory = false,
    geographyHistoryMeta,
    loadingCurrentHistory,
    currentHistory,
  } = useSelector(getGeographyData);
  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[GEOGRAPHY_MODULE].geographyHistoryMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: getValues(),
    };
    const p1 = dispatch(loadGeographyHistory(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const { getValues, control, setValue } = useFilterForm({}, loadData);

  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const handleSelectItem = i => {
    dispatch(loadHistoryById(i.id)).then(data => {
      setSelectedItem(i);
    }).catch(responseLogWithNotification);
  };

  const columns = [
    {
      dataField: 'user',
      text: 'Пользователь',
      headerClassName: 'user-column',
      formatter: userFullNameFormatter,
      disableSort: true,
    },
    {
      dataField: 'created_at',
      text: 'Дата и время',
      headerClassName: 'date-time-column',
      disableSort: true,
      formatter: dateTimeFormatter,
    },
    {
      dataField: 'geography',
      text: 'Гео объект',
      headerClassName: 'module-column',
      disableSort: true,
      formatter: (_, item) => (
        <NavLink to={`/geography?id=${item.id}`}>
          {item?.subject_name || 'Без имени'} от {dateFormatter(item?.created_at) || 'Без даты'}
        </NavLink>
      ),
    },
    {
      dataField: 'description',
      text: 'Изменения в объекте',
      headerClassName: 'changes-to-object-column',
      disableSort: true,
    },
  ];

  return (
    <div className="page geography-page">
      <Loader global loading={loadingGeographyHistory || loadingCurrentHistory} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.geography.history' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
            inputBefore={(
              <div className="search-wrapper">
                <Icons customIcon className="search" width={24} height={24} icon="search" />
              </div>
            )}
          />
          <FieldDTO
            control={control}
            dtoObject={{
              name: 'user_id',
              labelKey: 'user',
            }}
            usePortal
            className="no-border"
            addPlaceholder
            component={CustomSelectInputWithHelper}
            portalClassName="executor-selector"
            loadAction={loadUserList}
            optionFormatter={item => ({ value: item.id, name: item.full_name })}
            filterName="full_name"
          />
          <FieldDTO
            control={control}
            component={RangeDatePicker}
            dtoObject={{
              name: 'created_at',
              type: String,
              labelKey: 'created_at',
            }}
            hideSmallButtons
            showArrowIcon
            usePortal
            placeholder="Дата"
            changeFormat="YYYY-MM-DD"
            inputProps={{
              value: [getValues('created_at_from'), getValues('created_at_to')],
              onChange: e => {
                const v = e.target.value;
                setValue('created_at_from', v[0]);
                setValue('created_at_to', v[1]);
              },
            }}
            className="no-border"
          />
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid
                data={geographyHistory}
                columns={columns}
                name="geography-history-list"
                onClickByRow={handleSelectItem}
                rowClassFormatter={item => (selectedItem && item.id === selectedItem.id ? 'clickable-table-row selected' : 'clickable-table-row')}
              />
            </div>
          </div>
          <Pagination meta={geographyHistoryMeta} list={geographyHistory} handleChangeMeta={loadData} />
        </div>
      </div>
      {selectedItem && currentHistory ? <HistoryDialog onClose={() => setSelectedItem(null)} /> : null}
    </div>
  );
}
